import { motion, useReducedMotion } from 'framer-motion';
import { EASE, fadeIn, fadeUpItem, staggerParent } from '@/animations/variants';
import { asset } from '@/utils/assets';

export default function HeroSection() {
  const reduce = useReducedMotion();

  return (
    <section id="hero" className="relative w-full min-h-screen">
      {/* Background image */}
      <div className="absolute inset-0 overflow-hidden">
        <motion.img
          alt="ほぐし屋さん Luminosite 施術室"
          className="w-full h-full object-cover object-top"
          src={asset('images/hero.jpg')}
          initial={reduce ? false : { scale: 1 }}
          animate={reduce ? undefined : { scale: 1.04 }}
          transition={{ duration: 8, ease: 'easeOut' }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-deep-brown/55 via-forest/30 to-deep-brown/65"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-forest/40 via-transparent to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col justify-center min-h-screen px-6 sm:px-12 lg:px-20 pt-20">
        <motion.div
          className="max-w-2xl"
          variants={reduce ? fadeIn : staggerParent}
          initial="hidden"
          animate="visible"
        >
          <motion.p className="section-label mb-6 text-cream/90" variants={fadeUpItem}>
            HOGUSHIYA LUMINOSITE
          </motion.p>
          <motion.h1
            className="font-serif-jp text-white text-3xl sm:text-4xl lg:text-5xl leading-relaxed mb-6"
            variants={staggerParent}
          >
            <motion.span className="block" variants={fadeUpItem}>一人ひとりに寄り添う、</motion.span>
            <motion.span className="block" variants={fadeUpItem}>静かな隠れ家サロン。</motion.span>
            <motion.span className="block mt-2 text-lg sm:text-xl lg:text-2xl font-light" variants={fadeUpItem}>
              確かな技術を、落ち着いた空間で。
            </motion.span>
          </motion.h1>
          <motion.div
            className="w-16 h-px bg-cream/80 mb-6 origin-left"
            variants={reduce ? fadeIn : {
              hidden: { opacity: 0, scaleX: 0 },
              visible: { opacity: 1, scaleX: 1, transition: { duration: 0.6, ease: EASE } },
            }}
          />
          <motion.p
            className="font-sans-jp text-white/80 tracking-wider leading-loose text-sm sm:text-base"
            variants={fadeUpItem}
          >
            完全個室 / 肩甲骨はがし付き / 駅から徒歩3分
          </motion.p>
        </motion.div>

        {/* Scroll indicator */}
        <motion.div
          className="absolute bottom-10 left-1/2 flex flex-col items-center gap-2"
          initial={{ opacity: 0, x: '-50%' }}
          animate={reduce ? { opacity: 1, x: '-50%' } : { opacity: 1, x: '-50%', y: [0, 4, 0] }}
          transition={reduce ? { delay: 0.6, duration: 0.5 } : {
            opacity: { delay: 0.6, duration: 0.5 },
            y: { delay: 0.6, repeat: Infinity, duration: 2.4, ease: 'easeInOut' },
          }}
        >
          <span className="text-cream/80 font-sans-jp text-xs tracking-widest">SCROLL</span>
          <div className="w-px h-12 bg-gradient-to-b from-cream/80 to-transparent"></div>
        </motion.div>
      </div>
    </section>
  );
}